import Icon from '../icon/Icon';
import './ProductAnchorButton.less';
import { forwardRef } from 'preact/compat';

type ProductAnchorButtonProps = {
    selected?: boolean;
    onClick: (event: MouseEvent) => void;
    marginTop?: string;
    marginRight?: string;
};

const ProductAnchorButton = forwardRef<
    HTMLButtonElement,
    ProductAnchorButtonProps
>(
    (
        { selected = false, onClick, marginRight = '8px', marginTop = '8px' },
        ref
    ) => (
        <button
            type="button"
            className={`bri-ProductAnchorButton ${selected ? 'bri-selected' : ''}`}
            onClick={onClick}
            ref={ref}
            style={{ marginRight, marginTop }}
        >
            <Icon iconId="brilliant-logo" size="small" />
        </button>
    )
);

export default ProductAnchorButton;
